import Axios from "axios";
import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types";

const getInitialState = () => ({
  destination_id: null,
  paymentMethod: 'stripe',
  personalData: {
    name: "",
    lastName: "",
    email: "",
    newsletter: false,
    comments: ''
  },
  code: '',
});

export const giftState = {
  gifts: {
    locations: [],
    origin_id: null,
    passengers: 1,
    ...getInitialState()
  }
};

export const giftGetters = {
  [GETTER_TYPES.GIFTS_GET_DESTINATIONS](state) {
    const origin = state.gifts.locations.find(location => location.id === state.gifts.origin_id);

    if (!origin) return [];

    return origin.destinations.filter(destination => destination.pivot.visible);
  },
  [GETTER_TYPES.GIFTS_GET_ORIGINS_WITH_DESTINATIONS](state) {
    return state.gifts.locations.filter(location => {
      return location.destinations.some(destination => destination.pivot.visible);
    });
  },
  [GETTER_TYPES.GIFTS_GET_SELECTED_ORIGIN](state) {
    return state.gifts.locations.find(location => location.id === state.gifts.origin_id);
  },
  [GETTER_TYPES.GIFTS_FIND_DESTINATION_FROM_SLUG]: (state, getters)  => slug => {
    const origins = getters[GETTER_TYPES.GIFTS_GET_ORIGINS_WITH_DESTINATIONS];

    for (let origin of origins) {
      for (let destination of (origin.destinations)) {
        if (destination.pivot.visible && destination.slug === slug) {
          return destination;
        }
      }
    }
  },
  [GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION](state, getters) {
    return getters[GETTER_TYPES.GIFTS_GET_DESTINATIONS].find(destination => destination.id === state.gifts.destination_id);
  },
  [GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION_ORIGINS](state) {
    return state.gifts.locations.filter(location =>
      location.destinations.some(destination => {
        return destination.id === state.gifts.destination_id &&
          destination.pivot.visible;
      })
    )
  },
  [GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION_BASE_PRICE](state, getters) {
    if (! getters[GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION]) return 0;

    return parseFloat(getters[GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION].pivot.base_price);
  },
  [GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION_FINAL_PRICE](state, getters) {
    return getters[GETTER_TYPES.GIFTS_GET_SELECTED_DESTINATION_BASE_PRICE] * state.gifts.passengers;
  }
};

export const giftMutations = {
  [MUTATION_TYPES.RESET_GIFTS_STATE](state) {
    state.gifts = { ...state.gifts, ...getInitialState() };
  },
  [MUTATION_TYPES.SET_GIFTS_LOCATIONS](state, payload) {
    state.gifts.locations = payload;
  },
  [MUTATION_TYPES.SET_GIFTS_STATE](state, payload) {
    if (Array.isArray(payload)) {
      for (let { prop, value } of payload) {
        state.gifts[prop] = value;
      }
    } else {
      state.gifts[payload.prop] = payload.value;
    }
  }
};

export const giftActions = {
  [ACTION_TYPES.LOAD_GIFTS_LOCATIONS]({ commit, state }, payload) {
    return Axios.get('/api/locations').then(({ data }) => {
      commit(MUTATION_TYPES.SET_GIFTS_LOCATIONS, data);
    });
  }
};
